
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Component, ElementRef, OnInit, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, AbstractControl,Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';
import { SttTextRecordComponent } from 'src/app/components/stt-text-record/stt-text-record.component';
import { SttTextListComponent } from '../components/stt-text-list/stt-text-list.component';
import { IonSelectCustomEvent } from '@ionic/core';
import { SelectChangeEventDetail } from '@ionic/angular';
import { SttInferencedHistoryComponent } from '../components/stt-inferenced-history/stt-inferenced-history.component';

@Component({
  selector: 'app-sttinferencing',
  templateUrl: './sttinferencing.page.html',
  styleUrls: ['./sttinferencing.page.scss'],
})
export class SttinferencingPage implements OnInit {
  // variables for footer
  totalPages: number = 5;
  currentPage: number = 1;
  pageSize: number = 20;
  pageSizeOptions = [20, 50, 100];

  //variable for language
  selectedOption !: string | null;
  options = [
      { label: 'Dutch', value: 'nl' },
      { label: 'English', value: 'english' },
  ];


  textListData : any[] = []; // Full data from API
  searchQuery: string = ''; //variable for search

  constructor(
    private modalCtrl: ModalController,
    private globalService:GlobalService,
    private apiService: ApiService,
    private alertController: AlertController,
    private router:Router,
  ) {}
  ngOnInit(){
    this.retriveSTTTextList();
  }

  ionViewWillEnter() {
    this.currentPage = 1;
    this.selectedOption = localStorage.getItem('langCategory') || 'nl';

  }

  ionViewwillLeave() {
    this.searchQuery = '';
  }

  clearSearch(){
    this.searchQuery =  ''
    this.currentPage = 1;
    this.retriveSTTTextList();
  }

  onSearchInputChange(){
    // const query = this.ttsForm.get('searchQuery')?.value;
    if (this.searchQuery === '') {
      // Make API call when input is cleared
      this.clearSearch();
    }
  }

  onSearch(){
    this.currentPage = 1;
    console.log("Search function is called",this.searchQuery);
    this.retriveSTTTextList();
  }

  addSTTTextFun(){
    console.log("Add STT Text function is called");
    const text = "Add STT Text";
    this.showAlert()
  }

  async showAlert() {
  const alert = await this.alertController.create({
    header: 'Add Text',
    cssClass: 'custom-alert',
    inputs: [
      {
        name: 'newText',
        type: 'text',
        placeholder: 'Enter new text here !!!'
      }
    ],
    buttons: [
      {
        text: 'Cancel',
        role: 'cancel'
      },
      {
        text: 'Add',
        handler: (data) => {
          const textToAdd = data.newText?.trim();
          if (textToAdd) {
            this.globalService.logoutLoading();
            const language = localStorage.getItem('langCategory') || 'nl'; // Default to 'nl' if not set
            const user = localStorage.getItem('userName') || 'admin'; // Default user if not set
            const userId = localStorage.getItem('userId') || 'admin'; // Default user ID if not set
            this.apiService.addSTTText(textToAdd,language,user,userId).subscribe(
              () => {
                console.log("Text added successfully.");
                this.searchQuery =  ''
                this.currentPage = 1;
                this.retriveSTTTextList(); //refresh the list after adding new text
                
              },
              (err) => {
                console.error("Error adding text:", err);
              }
            );
          } else {
            console.warn("No text entered.");
          }
        }
      }
    ]
  });

  await alert.present();
  }

  deleteSTTTextFun(item: any) {
    
    console.log("text has been deleted",item);
    this.showDeleteAlert(item.guid,item.text);

  }
  updateRowValueOnDelete(guid: string) {
    this.textListData = this.textListData.filter(row => row.guid !== guid);
  }

  async showDeleteAlert(textId: string,text:string) {
    const alert = await this.alertController.create({
      header: 'Confirm Deletion',
      message: `Are you sure you want to delete "${text}"?`,
      cssClass: 'custom-alert',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Delete',
          handler: async () => {
            console.log("Delete STT Text function is called for item:", textId);
            this.apiService.deleteSTTText(textId).subscribe(
              () => {
                console.log("Text deleted successfully.");
                // this.retriveSTTTextList(); //refresh the list after deleting text
                this.updateRowValueOnDelete(textId);

              },
              (err) => {
                console.error("Error deleting text:", err);
              }
            );


          }
        }
      ]
    });
  
    await alert.present();
  }


  retriveSTTTextList() {
    try {
      this.globalService.logoutLoading();
      // const lang = localStorage.getItem('langCategory') || 'nl'; // Default to 'nl' if not set
      const lang = this.selectedOption || localStorage.getItem('language') || 'nl';
      const searchQuery = this.searchQuery.trim(); // Trim whitespace from search query
      this.apiService.getSTTTextList(lang,this.currentPage,this.pageSize,searchQuery).subscribe(
        async (response) => {
          console.log("Data get successfully:", response);
          this.textListData = response.data; // Assuming the API returns an array of text records
          this.totalPages = Math.ceil(response.totalCount / Number(this.pageSize)) || 1;
          await this.globalService.dismissLoading();
          
        },
        (err) => {
          this.totalPages = 1;
          this.textListData = [];
          console.error("Error during API call:", err);
          // alert("Failed to save data. Please try again.");
          this.globalService.dismissLoading();
        }
      );

    } catch (error) {
      console.error('Unexpected error while data loading:', error);
      alert('Failed to load data. Please try again.');
      this.globalService.dismissLoading();
    }
}

async onOptionChange($event: IonSelectCustomEvent<SelectChangeEventDetail<any>>) {
        this.searchQuery =  '';
        this.currentPage = 1;
        this.globalService.logoutLoading();
        const selectedLangForSTT = $event.detail.value;
        localStorage.setItem('langCategory', selectedLangForSTT);
        await this.retriveSTTTextList();
        
    }


updateCountValueForDeleteDataFromAllHistory(item:any,data:any) {
    const index = this.textListData.findIndex(row => row.guid === item.guid);
    if (index !== -1) {
        this.textListData[index].inferenceCount = Number(this.textListData[index].inferenceCount) - data["numberOfOwnDataDelete"];
        this.textListData[index].totalInferenceCount = Number(this.textListData[index].totalInferenceCount) - data["numberOfAllsDataDelete"];

    }
  }

async openPopupForSTTTextList() {
      this.searchQuery =  ''
      this.currentPage = 1; // Reset to first page when opening the modal
      const modal = await this.modalCtrl.create({
        component: SttTextListComponent,
        backdropDismiss: false,  // Prevent closing when clicking outside
        cssClass: 'large-modal-4', //custom class for styling
        componentProps:{
          'initiator':'FromSttTextListComponentForAllSTTInferecedData',
  
        }
      });
  
      await modal.present();
  
      const { data } = await modal.onDidDismiss();
      if (data) {
        // this.retriveSTTTextList();
        // console.log("DDDDDDDDDDDDDDDDDdata is:",data);
        // console.log("this.textListData",this.textListData);

        // for (const [key, value] of Object.entries(data)) {
        //   console.log('Key:', key);
        //   console.log('Value:', value);
        //   const result = this.textListData.find(item => item.guid === key);
        //   console.log("Result is:",result);
        // }
        
        if(Object.keys(data).length > 0){
          console.log("Data has been deleted");
          this.retriveSTTTextList();
        }else{
          console.log("No data has been deleted");
        }

        


        // textListData
        // this.updateCountValueForDeleteDataFromAllHistory("1","2");

      }else{
      }
    }


  openTextRecorFormModal(item: string) {
    console.log("text is:",item);
    // this.modalCtrl.create({
    //   component: FormAddTextForModelInferencingComponent,
    //   componentProps: { textId: item }
    // }).then(modal => {
    //   modal.present();
    // });

  }

  updateAddListDataCountValue(item:any,data:any) {
    console.log("TTTTTTTTtData is:",typeof data);
    const index = this.textListData.findIndex(row => row.guid === item.guid);
    if (index !== -1) {
        this.textListData[index].inferenceCount = Number(this.textListData[index].inferenceCount) + data;
        this.textListData[index].totalInferenceCount = Number(this.textListData[index].totalInferenceCount) + data;

    }
  }

  async openSTTTextRecorFormModal(item: any) {
      const modal = await this.modalCtrl.create({
        component: SttTextRecordComponent,
        backdropDismiss: false,  // Prevent closing when clicking outside
        cssClass: 'large-modal-2', //custom class for styling
        componentProps:{
          'initiator':'fromOpenSTTTextRecorFormModal',
          "text_info": item
  
        }
      });
  
      await modal.present();
  
      const { data,role } = await modal.onDidDismiss();
      if (role === 'save') {
          console.log("Dadadadadad ata is:",data);
          this.updateAddListDataCountValue(item,data)
  
      }else{
      }  
    }

  openSTTModelInferencePopup(item: string) {
    console.log("text is:",item);
  }

  updateDeleteListDataCountValue(item:any,data:any) {
    const index = this.textListData.findIndex(row => row.guid === item.guid);
    if (index !== -1) {
        this.textListData[index].inferenceCount = Number(this.textListData[index].inferenceCount) - data["numberOfOwnDataDelete"];
        this.textListData[index].totalInferenceCount = Number(this.textListData[index].totalInferenceCount) - data["numberOfAllsDataDelete"];

    }
  }

  async openSTTInferencedDataModal(item: any,user:string) {
      const currentUserIdForHistory = (user === 'current_user') ? (localStorage.getItem('userId') || '1') : user;
      console.log("tiiiiiem is:",item);
      const modal = await this.modalCtrl.create({
        component: SttInferencedHistoryComponent,
        backdropDismiss: false,  // Prevent closing when clicking outside
        cssClass: 'large-modal-3', //custom class for styling
        componentProps:{
          'initiator':'FromSttInferencedHistoryComponent',
          'currentTextIdForHistory': item.guid,
          'currentUserIdForHistory': currentUserIdForHistory,
          "showDataOf" : user,
          'selectedOptionLang': this.selectedOption || localStorage.getItem('language') || 'nl',
  
        }
      });
  
      await modal.present();
  
      const { data } = await modal.onDidDismiss();
      if (data) {
          console.log("IIIIIIIData is:",data);
          console.log("IIIIIIItem is:",item);
          this.updateDeleteListDataCountValue(item,data)

  
      }else{
      }  
    }

  closeModal(target:string) {
    this.modalCtrl.dismiss('close');    
  }

  onPageSizeChange(){
    this.currentPage = 1;
    console.log("Page size is:",this.pageSize);
    //make API call for retriveText()
    localStorage.setItem('currentPageSizeForHome',this.pageSize.toString());
    this.retriveSTTTextList();
    
  }

  goToFirstPage(){
    console.log("go to first page");
    this.currentPage = 1;

    //make API call for retriveText()
    localStorage.setItem('currentPageForHome',this.currentPage.toString());
    this.retriveSTTTextList();
    console.log("First Page is:",this.currentPage)
  }
  prevPage(): void{
    console.log("go to previous page");
    if (this.currentPage > 1) {
      this.currentPage--;

      //make API call for retriveText()
      localStorage.setItem('currentPageForHome',this.currentPage.toString());
      this.retriveSTTTextList();
      console.log("Previous Page is:",this.currentPage)
    }
  }
  nextPage(): void{
    // this.searchQuery = '';
    console.log("go to next page");
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      
      //make API call for retriveText()
      this.retriveSTTTextList();
      localStorage.setItem('currentPageForHome',this.currentPage.toString());

      console.log("Next Page is:",this.currentPage)
    }
  }
  goToLastPage(): void{
    console.log("go to last page");
    this.currentPage = this.totalPages;

    //make API call for retriveText()
    this.retriveSTTTextList();
    localStorage.setItem('currentPageForHome',this.currentPage.toString());

    console.log("Last Page is:",this.currentPage)
  }

  goToSpecificPage(pageNumber: number): void{
    console.log("Go to specific page number is:",pageNumber);

    console.log("go to specific page");
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.currentPage = pageNumber;
      // Any additional logic to handle page change

      //make API call for retriveText()
      this.retriveSTTTextList();
      localStorage.setItem('currentPageForHome',this.currentPage.toString());

      console.log("Current Page is:",this.currentPage);
    }
  }
  goToMenu() {
    this.router.navigate(['/menu']);
  }

  async confirmLogout() {
    // if(this.isRecording || this.hasUnsavedAudioData()){  
      const alert = await this.alertController.create({
            header: 'Confirm Logout',
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing when the user cancels
                    }
                },
                {
                    text: 'Logout',
                    handler: async () => {
                        // this.stopRecordingOnly();
                        await this.LogoutFunction();
                    }
                }
            ]
        });

        await alert.present();
      // }else{
      //   await this.LogoutFunction();
      // }
  }

  async LogoutFunction(){
  
      try{
          this.globalService.logoutLoading();
          const res:any = await this.apiService.logoutUser().toPromise();
              

          localStorage.removeItem('authenticationKey');
          localStorage.removeItem('accent');
          localStorage.removeItem('age');
          localStorage.removeItem('gender');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('language');

          localStorage.removeItem('searchedText');
          localStorage.removeItem('selectedModel');
          localStorage.removeItem('selectedModelLanguageForTTS');
          localStorage.removeItem('selectedFilterValueForTTS');
          
          localStorage.removeItem('selectedOptionUser');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('totalCountData');
          localStorage.removeItem('usersList');
          localStorage.removeItem('userRole');

          localStorage.removeItem('notRemoveModelInferencingData');
          localStorage.removeItem('numberOfRecordedText');
          localStorage.removeItem('numberOfTotalRecordedText');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('langCategory');
  
          this.globalService.dismissLoading();
        
          this.router.navigate(['login']);



        
      
      }catch(error){
        console.log("Error:", error);
        // this.globalService.dismissLoading();
        this.router.navigate(['login']);

      }
      
  };

}
